module.exports = __webpack_public_path__ + "img/IMG_0164.a753efbc.png";